import { render, staticRenderFns } from "./StartGuideNeedHelp.vue?vue&type=template&id=40ec1a48&scoped=true&"
import script from "./StartGuideNeedHelp.vue?vue&type=script&lang=ts&"
export * from "./StartGuideNeedHelp.vue?vue&type=script&lang=ts&"
import style0 from "./StartGuideNeedHelp.vue?vue&type=style&index=0&id=40ec1a48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec1a48",
  null
  
)

export default component.exports